<div class="topnav">
    <span class="navbar-icon ml-3" (click)="toggleNav()" data-toggle="tooltip-topNav" title="Press Esc Key to toggle">
        &#9776;
    </span>
</div>
<div id="sidenav" class="sidenav-collapse">
    <div class="container-fluid sidenav-buttons" id="sidenav-buttons">
        <div class="create mt-4 mb-3">
            <button type="button" class="btn create-button" data-toggle="modal" data-target="#projectModal">
                Create Project +
            </button>
        </div>
        <div class="create mt-5" *ngIf="!toggleUndoButton">
            <button type="button" class="btn undo-button" (click)="performUndoOperation()">
                Undo Changes
            </button>
        </div>
        <div class="search mt-5" data-toggle="modal" data-target="#searchModal">
            <button type="button" class="btn search-button" (click)="getAllUsers()">
                Search Users
            </button>
        </div>
        <div class="friends mt-5" data-toggle="modal" data-target="#friendsModal">
            <button type="button" class="btn friends-button" (click)="getAllFriendsOfUser()">
                Friends
            </button>
        </div>
        <div class="notifications mt-5" data-toggle="modal" data-target="#notificationModal">
            <button type="button" class="btn btn-warning notifications-button mr-1" (click)="getAllNotifications()">
                Notifications
            </button>
        </div>
        <div class="logout mt-5 mb-3">
            <button type="button" class="btn btn-danger logout-button" (click)="logoutUser()">
                Logout
            </button>
        </div>
    </div>
</div>
<!-- <div *ngIf="loaderService.loading | async">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div> -->
<div class="slider-bar" *ngIf="loaderService.loading | async">
    <div class="line-bar"></div>
    <div class="subline-bar inc"></div>
    <div class="subline-bar dec"></div>
</div>
<div class="modal fade" id="projectModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalCenterTitle">Enter your project name</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="projectModalForm" (ngSubmit)="mainModalFormSubmit()">
                <div class="modal-body">
                    <div class="form-group">
                        <input type="text" class="form-control" [ngClass]="{
                                'has-danger': ((projectModalForm.get('projectName').invalid && projectModalForm.get('projectName').dirty)||(projectModalForm.get('projectName').touched && projectModalForm.get('projectName').pristine)), 
                                'has-success': projectModalForm.get('projectName').valid && projectModalForm.get('projectName').dirty
                              }" formControlName="projectName" data-toggle="tooltip"
                            title="Maximum 25 alphanumeric characters">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="submit" [disabled]="!projectModalForm.get('projectName').valid"
                        class="btn btn-primary">Apply
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal fade" id="searchModal">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">People using toDo</h3>
                <button type="button" class="close" data-dismiss="modal">x</button>
            </div>
            <div class="col-12 col-sm-12 text-left mt-2">
                <h6 class="text-muted"> (Add only trusted users as Friend to avoid possible spam)</h6>
            </div>
            <div class="modal-body">
                <div class="card">
                    <ul class="list-group list-group-flush">
                        <div *ngFor="let users of allUserList; let i=index">
                            <li class="list-group-item">
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-5 col-sm-6 text-left">
                                            {{users.firstName}} {{users.lastName}}
                                        </div>
                                        <div class="col-7 col-sm-6 text-right">
                                            <button class="btn btn-dark" (click)="sendFriendRequest(users.userId)">Add
                                                Friend</button>
                                        </div>
                                    </div>
                                    <div class="row text-muted">
                                        <div class="col-6 col-sm-6">
                                            {{users.country}}
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </div>
                    </ul>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="notificationModal">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">Notifications</h3>
                <button type="button" class="close" data-dismiss="modal">×</button>
            </div>
            <div class="modal-body">
                <div class="card">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" *ngIf="!notificationModalFlag">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-sm-12">
                                        You don't have any notifications
                                    </div>
                                </div>
                            </div>
                        </li>
                        <div *ngFor="let notifications of notificationsList; let i=index">
                            <li class="list-group-item">
                                <div class="container-fluid">
                                    <div class="row" *ngIf="notificationModalFlag">
                                        <div class="col-12 col-sm-12"
                                            *ngIf="!notificationsMapping[notifications.notificationMessage]">
                                            {{notifications.notificationMessage}}
                                        </div>
                                        <div class="col-7 col-sm-8"
                                            *ngIf="notificationsMapping[notifications.notificationMessage]">
                                            {{notifications.notificationMessage}}
                                        </div>
                                        <div class="col-5 col-sm-4 text-right"
                                            *ngIf="notificationsMapping[notifications.notificationMessage]">
                                            <button class="btn btn-dark"
                                                (click)="addFriend(notifications.fromId)">Accept</button>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </div>
                    </ul>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="friendsModal">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">toDo Friends</h3>
                <button type="button" class="close" data-dismiss="modal">×</button>
            </div>
            <div class="modal-body">
                <div class="card">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" *ngIf="!friendsModalFlag">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-sm-12">
                                        You don't have any friends yet.
                                    </div>
                                </div>
                            </div>
                        </li>
                        <div *ngFor="let friend of friendsIdMapping; let i=index">
                            <li class="list-group-item">
                                <div class="container-fluid">
                                    <div class="row" *ngIf="friendsModalFlag">
                                        <div class="col-6 col-sm-7">
                                            {{friend.fullName}}
                                        </div>
                                        <div class="col-6 col-sm-5 connect-button">
                                            <button class="btn btn-dark"
                                                (click)="connectWithFriend(friend.userId,friend.fullName)">Connect</button>
                                            <span><img class="remove-image ml-4 ml-sm-3 mt-2"
                                                    src="/assets/remove-boy-user.svg" data-dismiss="modal"
                                                    (click)="updateFriendForRemoval(friend.userId)" data-toggle="modal"
                                                    data-target="#confirmationModal"></span>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </div>
                    </ul>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="confirmationModal" tabindex="-1" role="dialog"
    aria-labelledby="confirmationModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalCenterTitle">Remove this friend ? <p class="text-danger">You
                        will not be able to send another request</p>
                </h5>
                <button type="button" class="close" data-toggle="modal" data-target="#friendsModal" data-dismiss="modal"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body mx-auto">
                <button type="submit" class="btn btn-primary" (click)="removeFriend()" data-dismiss="modal">Yes
                </button>
                <button type="button" class="btn btn-secondary ml-5" data-toggle="modal" data-target="#friendsModal"
                    data-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="deleteProjectModal" tabindex="-1" role="dialog"
    aria-labelledby="confirmationModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalCenterTitle">Delete this project ? <p class="text-danger">This
                        action is irreversible !</p>
                </h5>
                <button type="button" class="close" data-toggle="modal" data-target="#friendsModal" data-dismiss="modal"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body mx-auto">
                <button type="submit" class="btn btn-primary" (click)="deleteProject()" data-dismiss="modal">Yes
                </button>
                <button type="button" class="btn btn-secondary ml-5" data-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>
<div id="main-content" class="main-content">
    <div class="sub-content" *ngIf="spinner">
        <div class="row ">
            <div class="container project-heading text-center">
                <div class="spinner-grow text-danger" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </div>
    <div class="sub-content" *ngIf="!toggleMainMessage && !spinner ">
        <div class="row ">
            <div class="container project-heading text-center">
                <h4>You have not created any projects :-(</h4>
            </div>
        </div>
    </div>
    <div class="sub-content" *ngIf="toggleMainMessage && !spinner">
        <div class="row ">
            <div class="container project-heading text-center">
                <h3>All projects</h3>
            </div>
        </div>
        <div class="row">
            <div *ngFor="let project of projectNamesList" class="col-sm-4 col-md-6 col-lg-4 col-xl-3">
                <div class="card text-center text-white bg-dark mb-3"
                    style="max-width: 30rem;height:11rem;border-radius:10px;">
                    <div class="card-body">
                        <h5 class="card-title">{{project}}</h5>
                    </div>
                    <div class="card-footer text-muted footer">
                        <button class="btn btn-primary btn-md" (click)="goToViewTask(project)">View
                            Tasks
                        </button>
                        <span><button class="btn btn-danger btn-md ml-3" data-toggle="modal"
                                data-target="#deleteProjectModal" (click)="updateProjectName(project)">Delete
                            </button></span>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>